export default __webpack_public_path__ + "static/7-d07e8e52edc8fc7ff8e1f5658431c11e.jpg";